/**
 * Gate 1 — Step 2: Risk Register REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = (projectId) => `${API_BASE_URL}/projects/${projectId}/gate1/risk-register`;

export async function fetchRiskRegister(projectId) {
  const res = await axios.get(base(projectId));
  return res.data;
}

export async function generateRiskRegister(projectId) {
  const res = await axios.post(`${base(projectId)}/generate`);
  return res.data;
}

export async function addRisk(projectId, risk) {
  const res = await axios.post(`${base(projectId)}/risks`, risk);
  return res.data;
}

export async function updateRisk(projectId, riskId, patch) {
  const res = await axios.put(`${base(projectId)}/risks/${riskId}`, patch);
  return res.data;
}

export async function deleteRisk(projectId, riskId) {
  const res = await axios.delete(`${base(projectId)}/risks/${riskId}`);
  return res.data;
}
